import { HTTP_TYPES } from '@/lib/enums';
import api from '@/api/api';

const response = {
    async postGetProfiles(payload: any, params?: any): Promise<any> {
        return await api(
            HTTP_TYPES.POST,
            `${import.meta.env.VITE_DEPOT_API_ADMIN}/profiles/`,
            payload,
            params
        );
    },
    async getProfilesByPlaceId(placeId: string): Promise<any> {
        return await api(
            HTTP_TYPES.GET,
            `${import.meta.env.VITE_DEPOT_API_ADMIN}/profiles/place/${placeId}`
        );
    },
    async getAllGoogleProfileIdsWithPlaceIds(): Promise<any> {
        return await api(
            HTTP_TYPES.GET,
            `${import.meta.env.VITE_DEPOT_API_ADMIN}/profiles/placeids`
        );
    },
    async getProfileCount(type: string, date?: string): Promise<any> {
        const params: { type?: string; from_date?: string } = {};

        if (type) {
            params.type = type;
        }

        if (date) {
            params.from_date = date;
        }

        return await api(
            HTTP_TYPES.GET,
            `${import.meta.env.VITE_DEPOT_API_ADMIN}/profiles/count/`,
            null,
            params
        );
    },
    async getProfileCountByMonth(type?: string, date?: string): Promise<any> {
        const params: { type?: string; from_date?: string } = {};

        if (type) {
            params.type = type;
        }

        if (date) {
            params.from_date = date;
        }

        return await api(
            HTTP_TYPES.GET,
            `${import.meta.env.VITE_DEPOT_API_ADMIN}/profiles/count-by-month/`,
            null,
            params
        );
    },
    /**
     * Upload a profiles-list CSV and get it back with each row's Depot profile
     * reference data appended. Rows are matched on `profile_uuid`.
     *
     * NOTE: the endpoint path is `enrich-channel-list`, not `enrich-profiles-list`.
     * The UI, route and store action are named for a profiles list, but the path is
     * the backend's contract — do not "correct" it here.
     *
     * `formData` must carry the file under the field name `file`. Content-Type is
     * left unset by the API layer so the browser can add the multipart boundary.
     */
    async enrichProfilesList(formData: FormData): Promise<any> {
        return await api(
            HTTP_TYPES.POST,
            `${import.meta.env.VITE_DEPOT_API_ADMIN}/profiles/enrich-channel-list`,
            formData,
            undefined,
            'application/json',
            'v1',
            { Accept: 'text/csv' }
        );
    },
    async postUpdateSubscribedTripadvisorsToFetchResponses(payload: any): Promise<any> {
        // fetch_responses_only: [guid]

        return await api(
            HTTP_TYPES.POST,
            `${import.meta.env.VITE_DEPOT_API_ADMIN}/profiles/update-subscribed-tripadvisor`,
            payload
        );
    }
};

export default response;
